import { Injectable } from '@angular/core';
// import {User} from './model/user.model';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { throwError } from 'rxjs';
import {Observable} from 'rxjs/index';
import { map, catchError } from 'rxjs/operators';
import {GlobalVariable} from '../../global';
import {Subject} from 'rxjs/index';

@Injectable()
export class ActivationCodeListService {

  public logOutSubject: Subject<any> = new Subject<any>();

  constructor(private http: HttpClient) {
  }

  getRootPwd(body) {
    return this.http.post(GlobalVariable.BASE_API_URL+'/getRootPwd.php', body)
    .pipe(
      map(
        (response: any) => { return response; }
      ),
      catchError(
        (error: HttpErrorResponse) => {
          console.log(error);
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      )
    )  
  }

  getActivationCodeList() {
    return this.http.get(GlobalVariable.BASE_API_URL+'/getActivationCodeList.php')
    .pipe(
      map(
        (response: any) => { return response; }
      ),
      catchError(
        (error: HttpErrorResponse) => {
          console.log(error);
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      )
    )  
  }

  deleteActivationCode(body) {
    return this.http.post(GlobalVariable.BASE_API_URL+'/deleteActivationCode.php', body)
    .pipe(
      map(
        (response: any) => { return response; }
      ),
      catchError(
        (error: HttpErrorResponse) => {
          console.log(error);
          return Observable.throw({
            code: error.status,
            content: JSON.parse(error.error).message
          });
        }
      )
    )  
  }

}
